<div class="{{ theme }}" [ngClass]="{'in-progress': (requestInProgress || updating)}">

  <div [ngClass]="{'empty-div': offerState.mode === 'LIST'}" *ngIf="!isDateCourte">
    <div class="group tooltip" attr.data-tooltip="{{ 'product.unpackedQuantity' | translate }} :  {{ unpackedQuantity }}" *ngIf="((showDecolise == false))">
      <button *ngIf="((unpackedQuantity || 0).toString() != '0') && !(requestInProgress || updating)" debounceClick (debounceClick)="validateInput()"
              (debounceStart)="setUserActionPending()" [disabled]="!canSelectUnpackedQuantity() || this.productQuantity == 0" (click)="onUnpackedQuantityInput(true)">

        <span class="display-quantity-number">- {{ unpackedQuantity }}</span>
      </button>
    </div>
  </div>

  <!--Groupe dans le cas ou on est en colis complet-->
  <div class="group" *ngIf="((isDecolise == false))">
    <button decolise *ngIf="((showDecolise == true))" (click)="onModeChangeClick()" data-toggle="tooltip" data-placement="right" title="Mode colis complet - Passer en mode décolisé" margin="0">
      <span margin="0" class="fa fa-box"></span>
    </button>
    <span *ngIf="((showDecolise == true))">&nbsp;</span>
    <button debounceClick (debounceClick)="validateInput()" (debounceStart)="setUserActionPending()" [disabled]="!canRemoveProduct || (requestInProgress || updating)"
            (click)="onQuantityIncreaseOrDecrease(-1)" [ngClass]="{'quantity-size': offerState.mode === 'LIST'}">
      <!--i class="fa fa-minus"></i--><span class="display-quantity-number">- {{ outer }}</span>
    </button>
    <span class="cart-number">
      <input type="text"
             [disabled]="(!canAddProduct && !canRemoveProduct) || availability?.availability === 0 || (requestInProgress || updating)"
             [(ngModel)]="productQuantity" (keyup)="onKeyUp($event)" (keypress)="onQuantityInput($event)"
             (blur)="onBlur(); validateInput()">
    </span>
    <button debounceClick (debounceClick)="validateInput()" (debounceStart)="setUserActionPending()"
            [disabled]="!canAddProduct || availability?.availability === 0 || (requestInProgress || updating)"
            (click)="onQuantityIncreaseOrDecrease(1)" [ngClass]="{'quantity-size': offerState.mode === 'LIST'}">
      <!--i class="fa fa-plus"></i--><span class="display-quantity-number">+ {{ outer }}</span>
    </button>
  </div>

  <!--Groupe dans le cas ou on est en colis partiel / Décolisage -->
  <div class="group" *ngIf="isDecolise == true && !isDateCourte">
    <button decolise *ngIf="showDecolise == true" (click)="onModeChangeClick()" data-toggle="tooltip" data-placement="right" title="Mode colis complet - Passer en mode décolisé">
      <span class="fa fa-balance-scale"></span>
    </button>
    <span *ngIf="showDecolise == true">&nbsp;</span>
    <button debounceClick (debounceClick)="validateInput()" (debounceStart)="setUserActionPending()" [disabled]="!canRemoveProduct || (requestInProgress || updating)"
            (click)="onQuantityIncreaseOrDecrease(-1)" [ngClass]="{'quantity-size': offerState.mode === 'LIST'}">
      <span class="display-quantity-number">- 1</span>
    </button>
    <span class="cart-number">
      <input type="text"
             [disabled]="(!canAddProduct && !canRemoveProduct) || availability?.availability === 0 || (requestInProgress || updating)"
             [(ngModel)]="productQuantity" (keyup)="onKeyUp($event)" (keypress)="onQuantityInput($event)"
             (blur)="onBlur(); validateInput()">
    </span>
    <button debounceClick (debounceClick)="validateInput()" (debounceStart)="setUserActionPending()"
            [disabled]="!canAddProduct || availability?.availability === 0 || (requestInProgress || updating)"
            (click)="onQuantityIncreaseOrDecrease(1)" [ngClass]="{'quantity-size': offerState.mode === 'LIST'}">
      <span class="display-quantity-number">+ 1</span>
    </button>
  </div>

  <div [ngClass]="{'empty-div': offerState.mode === 'LIST'}" *ngIf="!isDateCourte">
    <div class="group tooltip" attr.data-tooltip="{{ 'product.unpackedQuantity' | translate }} :  {{ unpackedQuantity }}" *ngIf="((showDecolise == false))">
      <button *ngIf="((unpackedQuantity || 0).toString() != '0') && !(requestInProgress || updating)" debounceClick (debounceClick)="validateInput()"
              (debounceStart)="setUserActionPending()" [disabled]="!canSelectUnpackedQuantity()" (click)="onUnpackedQuantityInput(false)">

        <span class="display-quantity-number">+ {{ unpackedQuantity }}</span>
      </button>
    </div>
  </div>
  <!--span *ngIf="((unpackedQuantity || 0).toString() == '0') && !(requestInProgress || updating)" class="tooltip" attr.data-tooltip="{{ 'product.outer' | translate }}: {{ outer }}">
  </span>
  <span *ngIf="((unpackedQuantity || 0).toString() != '0') && !(requestInProgress || updating)" class="tooltip" attr.data-tooltip="{{ 'product.outer' | translate }}: {{ outer }}, {{ 'product.unpackedQuantity' | translate }}: {{ unpackedQuantity }}">
    <i class="fa fa-question-circle"></i>
  </span-->
</div>
<div *ngIf="(requestInProgress || updating)" class="in-progress-overlay">
  <i class="fa fa-spin fa-circle-notch"></i>
</div>
